import React from "react";
import { AiOutlineFileUnknown, AiOutlineFolder } from "react-icons/ai";
import { BsImage } from "react-icons/bs";
import { HiOutlineDocument } from "react-icons/hi";
import { VscFilePdf } from "react-icons/vsc";
import { FaFileAudio } from "react-icons/fa";
import { MdVideoLibrary } from "react-icons/md";
import { BiLockAlt } from "react-icons/bi";

const imageExtensions: string[] = ["jpg", "jpeg", "png"];
const audioExtensions: string[] = ["m4a", "mp3", "flac", "wav", "aac"];
const videoExtensions: string[] = [
  "webm",
  "mp4",
  "mpeg",
  "ogg",
  "avi",
  "mov",
  "flv",
];
const excelExtensions: string[] = ["xlsx", "ods", "xls"];
const docsExtensions: string[] = ["docx", "docm", "doc"];
const pdfExtensions: string[] = ["pdf"];

export const getFileIcon = (
  filename: string,
  encrypted: boolean = false
): JSX.Element | null => {
  let icon: JSX.Element | null = <AiOutlineFileUnknown />;
  if (encrypted) {
    icon = <BiLockAlt />;
  } else {
    filename = filename?.toLowerCase();
    const fileArr: string[] | undefined = filename?.split(".");
    const fileExtension: string = fileArr ? fileArr?.[fileArr?.length - 1] : "";
    fileExtension === filename && (icon = <AiOutlineFolder />);
    imageExtensions.includes(fileExtension) && (icon = <BsImage />);
    docsExtensions.includes(fileExtension) && (icon = <HiOutlineDocument />);
    pdfExtensions.includes(fileExtension) && (icon = <VscFilePdf />);
    audioExtensions.includes(fileExtension) && (icon = <FaFileAudio />);
    videoExtensions.includes(fileExtension) && (icon = <MdVideoLibrary />);
  }

  return icon;
};
